import React, { useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  showToast,
  Skeleton,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { updateSubmissionStatus } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { useSelector } from "react-redux";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import { formatPhoneNumberLength, formatWords2 } from "../../../../utils/stringUtils";
import { Link } from "react-router-dom";

const JobsAccordion = ({ rowData, type, loading = false, sourceFrom, onStatusUpdate }) => {
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState(null)
  const { user } = useSelector((state) => state.auth);
  const [loader, setLoader] = useState(false);

  //console.log(rowData)
  const ApplicantSubStatus = {
    1: "Shortlisted",
    2: "Pipeline",
    3: "Submitted",
    4: "Review call by BDM",
    5: "BDM Interview",
    6: "Disqualified",
    7: "Hold",
    8: "Withdrawn",
    9: "Waiting for Writeup",
    10: "Submitted to Client",
    11: "Submitted To Vendor",
    12: "Shortlisted for Interview",
    13: "Interview Confirmation",
    14: "Interview Scheduled",
    15: "L1 Interview Scheduled",
    16: "L2 Interview Scheduled",
    17: "L3 Interview Scheduled",
    18: "L1 Interview Selected",
    19: "L2 Interview Selected",
    20: "L3 Interview Selected",
    21: "L1 Interview Rejected",
    22: "L2 Interview Rejected",
    23: "L3 Interview Rejected",

    24: "L1 Interview Re-Scheduled",
    25: "L2 Interview Re-Scheduled",
    26: "L3 Interview Re-Scheduled",

    27: "L1 Interview Feedback Pending",
    28: "L2 Interview Feedback Pending",
    29: "L3 Interview Feedback Pending",

    30: "Rejected By Client",
    31: "Selected but no response from the client",
    32: "Rejected after Client Selection",

    33: "Submitted to End Client",

    34: "Vendor Interview",
    35: "Vendor Interview Reject",

    36: "Client Interview",
    37: "Client Interview Select",
    38: "Client Interview Reject",
    39: "Client Interview Completed",

    40: "End Client Interview",
    41: "End Client Interview Completed",

    42: "Selected By Vendor",
    43: "Selected By Client",
    44: "Selected By End Client",

    45: "Rejected By Vendor",
    46: "Rejected by End Client",

    47: "Disqualified By Vendor",
    48: "Disqualified By Client",
    49: "Disqualified by End Client",

    50: "Hold By Vendor",
    51: "Hold By Client",
    52: "Hold by End Client",

    53: "Drop",
    54: "Position on Hold",

    55: "PW Interview Proposed By Buyer",
    56: "PW Interview Proposed By Supplier",
    57: "PW Interview Failed",
    58: "PW Interview Cancelled",
    59: "PW Interview Success",

    60: "Assignment Contract Sent",
    61: "Assignment Contract Verified",
    62: "Assignment Contract Rejected",

    63: "Confirmed",
    64: "Position Filled",
    65: "Backout",
    66: "Not Joined",
    67: "BGV Failed",
    68: "Got Pay Rate Confirmation",
    69: "Offer Withdrawn",
    70: "Negotiation",
    71: "Start",
    72: "Offer Sent",
    73: "Offer Accepted",
    74: "Offer Rejected",
    75: "Hold with Client",
    76: "Hold with Vendor",
    77: "Rejected Internally",
  };
   // };
  const SourceMap = {
    1: "Internal DB",
    2: "Career Builder",
    3: "Monster",
    4: "Career Portal",
    5: "CareerJet",
    6: "Dice",
    7: "Glassdoor",
    8: "Indeed",
    9: "LinkedIn",
    10: "Naukari",
    11: "Neuvoo",
    12: "Post Job Free",
    13: "Snaprecruit",
    14: "Stack Overflow",
    15: "ZipRecruiter",
    16: "Employee Referral",
    17: "Employment Agency",
    18: "Gmail",
    19: "Job Fair",
    20: "Others",
    21: "Outlook",
    22: "Passive Sourcing",
    23: "Resume Inbox"
  };
  const ApplicantSubStatusOptions = Object.entries(ApplicantSubStatus).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    })
  );

  const columns = [
    {
      key: "submissionId",
      label: "Submission ID",
    },
    {
      key: "applicantName",
      label: "Applicant Name",
      render: (row) => (
        <Link
          to={`/ats/applicants/applicant-details`}
          state={{ applicantId: row.candidateId, source: sourceFrom ?? "recruit-alljobs" }}
          className="text-info-400 flex items-center gap-.5"
        >
          <span className="mx-2">{formatWords2(row.applicantName)}</span>
        </Link>
      ),
    },
    {
      key: "workAuth",
      label: "Work Authorization",
    },
    {
      key: "mobile",
      label: "Mobile Number",
    },
    {
      key: "applicantLocation",
      label: "Location",
    },
    {
      key: "country",
      label: "Country",
    },
    {
      key: "experience",
      label: "Experience",
    },
 {
      key: "source",
      label: "Source",
      render: (row) => {
        const sourceText = SourceMap[row.source] || row.source || "Unknown";
        return <span>{sourceText}</span>;
      }
    },
    {
      key: "resume",
      label: "Resume",
    },
    {
      key: "revisionStatus",
      label: "Revision Status",
      render: (row) => <StatusTags tag={row.revisionStatus} variant="text" />,
    },
    {
      key: "applicationStatus",
      label: "Application Status",
      render: (row) => {
        const lastStatusEntry =
          row.applicationStatus?.[row.applicationStatus.length - 1];
        const statusNumber = lastStatusEntry?.status || 1; // fallback
        const currentOption =
          ApplicantSubStatusOptions.find((opt) => opt.value === statusNumber) ||
          ApplicantSubStatusOptions[0];

        return (
          <div className="w-[220px]">
            <FormFieldSet
              type="select"
              noTitle
              size="sm"
              options={ApplicantSubStatusOptions}
              value={currentOption}
              showSearch
              onChange={(option) => handleUpdateSubmissionStatus(option, row)}
            />
          </div>
        );
      },
    },

    {
      key: "billRate",
      label: "Bill Rate",
    },
    {
      key: "payRate",
      label: "Pay Rate",
    },
    {
      key: "employerName",
      label: "Employer Name",
    },
    {
      key: "availability",
      label: "Availability",
    },
    {
      key: "submittedBy",
      label: "Submitted By",
    },
    {
      key: "pwSubmissionType",
      label: "PW Submission Type",
    },
    {
      key: "noticePeriod",
      label: "Notice Period",
    },
    {
      key: "currentCTC",
      label: "Current CTC",
    },
    {
      key: "submittedOn",
      label: "Submitted On",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={"visibility"}
            onClick={() => {
              setSelectedId(row?.candidateId)
              setDetailsDrawer(true);
            }}
            color="black"
            size="sm"
          />
          <Link
            to={`/ats/applicants/applicant-details`}
            state={{ applicantId: row?.candidateId, source: sourceFrom == "recruit-myjobs" ? "recruit-myjobs-edit" : "recruit-alljobs-edit" }}
            className="text-info-400 flex items-center gap-.5"
          >
            <Button
              type="icon"
              variant="text"
              icon={"edit_square"}
              color="black"
              size="sm"
            />
          </Link>
          <Button
            type="icon"
            variant="text"
            icon={"delete"}
            color="black"
            size="sm"
          />
        </div>
      ),
    },
  ];
  // const rows = Array.from({ length: 2 }, (_, index) => ({
  //   submissionId: 21345,
  //   applicantName: "Mahesh Babu",
  //   workAuth: "US",
  //   mobile: "+1 (732) 456-7890",
  //   location: "Texas - US",
  //   country: "USA",
  //   experience: "2 years",
  //   source: "naukri",
  //   resume: "Resume",
  //   revisionStatus: "Active",
  //   applicationStatus: "In Progress",
  //   billRate: "USD-100000-130000/Ye",
  //   payRate: "USD/130000/Yearly/Full",
  //   employerName: "Arshad",
  //   availability: "Yes",
  //   submittedBy: "Chandan",
  //   pwSubmissionType: "Referal",
  //   noticePeriod: "30 Days",
  //   currentCTC: "USD/130000/Yearly/Full",
  //   submittedOn: "July 08, 2025 02:40:55 PM",
  // }));

  const handleUpdateSubmissionStatus = async (option, row) => {
    try {
      setLoader(true);
      const newStatus = option;
      const payload = [
        {
          type: "PUSH",
          value: {
            statusHistory: {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
            },
          },
        },
      ];

      const res = await updateSubmissionStatus({
        coll: "Submission",
        uiid: row.submissionId,
        payload,
      });

      if (res?.data) {
        showToast("Submission status updated", "success");
        if (onStatusUpdate) {
          onStatusUpdate({
            submissionId: row.submissionId,
            candidateId: row.candidateId,
            newStatus,
            type
          });
        }
      } else {
        showToast("Failed to update", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update", "error");
    } finally {
      setLoader(false);
    }
  };

  // const mappedRows = mapTableRows(rows, columns);
  const newRowData = rowData?.map(data => ({
    ...data,
    mobile: data?.mobile?.replace(/\D/g, "")?.length
      ? formatPhoneNumberLength("+1", data?.mobile)
      : data?.mobile
  }));
  const rows = rowData?.length ? newRowData : [];
  const mappedRows = mapTableRows(rows, columns);
  const padding = "p-4";
  const tableConfigs = {
    applications: {
      name: "Applications",
      columns: columns,
      rows: mappedRows,
    },
    shortlisted: {
      name: "Shortlisted",
      columns: columns,
      rows: mappedRows,
    },
    pipelined: {
      name: "Pipelined",
      columns: columns,
      rows: mappedRows,
    },
    submitted: {
      name: "Submitted",
      columns: columns,
      // rows: submittedRows,
      rows: mappedRows,
    },
  };

  const config = tableConfigs[type];

  return (
    config && (
      <div className={`${padding}`}>
        <h6 className="m-1">
          {config.name} : {config.rows?.length ?? 0}
        </h6>
        {/* <NewTableAdv columns={config.columns} rows={config.rows} hideToolBar /> */}
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <LogoLoader />
          </div>
        ) : (
          <TableAdv columns={columns} rows={config.rows} hideToolBar />
        )}
        <ApplicantsDetailsDrawer
          isOpen={detailsDrawer}
          onClose={() => setDetailsDrawer(false)}
          applicantId={selectedId}
        />
        <Backdrop isOpen={loader}>
          <LogoLoader />
        </Backdrop>
      </div>
    )
  );
};

export default JobsAccordion;
